import React from 'react';
import PageLayout from '../components/common/PageLayout';
import WebCheckInList from '../components/booking/WebCheckInList';

const WebCheckInListPage = () => (
  <PageLayout
    title="Web Check-in"
    showBookingSectionTabs
    navLinks={[
      { url: '/booking/list/', label: 'Booking List' },
      { url: '/booking/reservation/', label: 'Reservation' },
    ]}
  >
    <WebCheckInList />
  </PageLayout>
);

export default WebCheckInListPage;
